import { BookOpen, Megaphone, UsersThree, Storefront, Tag, Link, Gift, Heart, Star, ShoppingBag } from '@phosphor-icons/react';

// Conjunto curado de ícones para categorias de tipo de recurso (Recomendações).
export const RESOURCE_ICONS = { BookOpen, Megaphone, UsersThree, Storefront, Tag, Link, Gift, Heart, Star, ShoppingBag };

export const RESOURCE_ICON_OPTIONS = [
  { value: 'BookOpen', label: 'Livro' },
  { value: 'Megaphone', label: 'Megafone' },
  { value: 'UsersThree', label: 'Pessoas' },
  { value: 'Storefront', label: 'Loja' },
  { value: 'Tag', label: 'Etiqueta' },
  { value: 'Link', label: 'Link' },
  { value: 'Gift', label: 'Presente' },
  { value: 'Heart', label: 'Coração' },
  { value: 'Star', label: 'Estrela' },
  { value: 'ShoppingBag', label: 'Saco' },
];

export const resourceIcon = (name) => RESOURCE_ICONS[name] || Tag;
